import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Landing from "./components/Landing";
import MapView from "./components/Map/MapView";
import 'leaflet/dist/leaflet.css';


function App() {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/" element={<Landing onStart={() => navigate("/map")} />} />
      <Route path="/map" element={<MapView />} /> 
    </Routes>
  );
}

export default App;
